import { Branding } from "@/modules/profile/pages/branding";
import { createFileRoute, notFound } from "@tanstack/react-router";
import { getUserOptions } from "creso-core/hooks";
import { isEmployeeUser } from "creso-core/utils";

function BrandingRoute() {
  return <Branding />;
}
export const Route = createFileRoute("/(auth)/_headed/account/branding")({
  component: BrandingRoute,
  loader: async ({ context }) => {
    const { queryClient } = context;
    const user = await queryClient.ensureQueryData(getUserOptions());
    if (isEmployeeUser(user.user_type)) {
      throw notFound({ routeId: "__root__" });
    }
  },
});
